import React from "react";

function NoDataIcon() {
  return (
    <>
      <svg
        width="54"
        height="54"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="54" height="54" rx="27" fill="#F3F4F6" />
        <path
          d="M29.5 36C29.5 36.4945 29.3534 36.9778 29.0787 37.3889C28.804 37.8 28.4135 38.1205 27.9567 38.3097C27.4999 38.4989 26.9972 38.5484 26.5123 38.452C26.0273 38.3555 25.5819 38.1174 25.2322 37.7678C24.8826 37.4181 24.6445 36.9727 24.548 36.4877C24.4516 36.0028 24.5011 35.5001 24.6903 35.0433C24.8795 34.5865 25.2 34.196 25.6111 33.9213C26.0222 33.6466 26.5055 33.5 27 33.5C27.663 33.5 28.2989 33.7634 28.7678 34.2322C29.2366 34.7011 29.5 35.337 29.5 36ZM27 31C27.3978 31 27.7794 30.842 28.0607 30.5607C28.342 30.2794 28.5 29.8978 28.5 29.5V17C28.5 16.6022 28.342 16.2206 28.0607 15.9393C27.7794 15.658 27.3978 15.5 27 15.5C26.6022 15.5 26.2206 15.658 25.9393 15.9393C25.658 16.2206 25.5 16.6022 25.5 17V29.5C25.5 29.8978 25.658 30.2794 25.9393 30.5607C26.2206 30.842 26.6022 31 27 31Z"
          fill="#65758B"
        />
      </svg>
    </>
  );
}

export default NoDataIcon;
